import { call, put, takeEvery, select, delay } from 'redux-saga/effects';

import { SAGA_ERROR } from '../../../helpers/constants';
import { SEND_INTERNAL_CHAT_MESSAGE } from '../../../helpers/internalChatConstants';
import { internalChatMessageObject } from '../utils/internalChatMessageObject';

import {
    addTemporaryMessage,
    markMessageAsFailed,
    removeMessageFromList,
    resolveSendedAttachments,
    sendMessageRequest,
    updateMessageStatus
} from '../utils/internalChatFunctions/sendInternalChatMessageFunc';

import { errorTypes, errorOrigin } from '../utils/toastActionCreator';

const getContacts = state => state.internalChat.contacts;
const getActiveChat = state => state.internalChat.activeChat;

function* sendInternalChatMessage(action) {

    const contacts = yield select(getContacts);
    const activeChat = yield select(getActiveChat);

    const files = action.data.files || [];
    const message = internalChatMessageObject(activeChat.user, action.data);

    try {
    /** Add a temporary message */
    yield put(addTemporaryMessage(contacts, message));

    /** Remove the message of the list messaging state object */
    yield put(removeMessageFromList());

    /** Make a POST resquest to store de message in the database */
    const { data, response } = yield call(sendMessageRequest, message, activeChat, files);

    if (data) {
        /** A API devolve os identificadores da mensagem enfileirada; os anexos
         *  persistidos podem não vir junto, e nesse caso são buscados pela mensagem.
         */
        const sendedMessages = Array.isArray(data) ? data : [data];
        const sendedMessage = sendedMessages.find(m => m.externalReference === message.externalReference) || sendedMessages[0];

        const attachments = yield call(resolveSendedAttachments, sendedMessage, files);

        /** Update message based on the POST response */
        const updatedContacts = yield select(getContacts);
        yield put(updateMessageStatus(updatedContacts, sendedMessages, attachments));
    } else {
        const updatedContacts = yield select(getContacts);

        yield put(markMessageAsFailed(updatedContacts, message));

        yield put({
            type: SAGA_ERROR,
            origin: errorOrigin.backend,
            errorType: errorTypes.error,
            response: response
        });
    }


    } catch (e) {
        const updatedContacts = yield select(getContacts);
        yield put(markMessageAsFailed(updatedContacts, message));

        yield put({
            type: SAGA_ERROR,
            origin: errorOrigin.saga,
            errorType: errorTypes.error,
            response: e.message
        });

    }
}

export default function* sendInternalChatMessageSaga() {
    yield takeEvery(SEND_INTERNAL_CHAT_MESSAGE, sendInternalChatMessage);
}
